import React, { useState, useEffect } from 'react'
import axios from './axios';
import requests from './requests';
import './Banner.css'

function Banner() {
    const [movie, setMovie] = useState ([]);
    useEffect(() => {
        async function fetchData() {
            const result = await axios.get(requests.fetchNetflixOriginals);
            setMovie(result.data.results[Math.floor(Math.random() * (result.data.results.length-1))]);
            //chooses a random Netflix original movie using Math.random
            return result;
        }
        fetchData();
    }, [])

    function truncate(str, n) {
        return str?.length > n ? str.substr(0, n-1) + "..." : str;
    }

    return (
        <header className="banner"
        style={{
            backgroundSize: "cover",
            //movie'?' is used to cover scenario of 'If movie available, do this'
            backgroundImage: `url(
                "https://image.tmdb.org/t/p/original/${movie?.backdrop_path}"
            )`,
            backgroundPosition: "center center",
        }}> 
            <div className="banner__content">
            {/* title */}
            <h1 className="banner__title">
                {movie?.title || movie?.name || movie?.original_name}
                {/* ? handles the exitance of property like name, title etc, || handles the selection of whatever available */}
                {/* this is called Optional chaning */}
            </h1>
            {/* div -> 2 buttons */}
            <div className="banner__buttons">
            <button className="banner__button">Play</button>
            <button className="banner__button">My List</button>
            </div>
            {/* Desc  */}
            <h1 className="banner__description">
                {truncate(movie?.overview, 150)}
            </h1>
            </div>
            <div className="banner__fadeBottom"></div>
        </header>
    )
}

export default Banner
